import { odata } from '@bingads-webui/http-util';
import _ from 'underscore';

export const fetchPerformanceInsightsData = ({ serverContext }) => {
  const odataPath = 'AdInsight/V2';
  const oDataConfig = {
    odataToken: serverContext.Token,
    odataPath: `${serverContext.ServicesEndpoints.AdInsightAPI}${odataPath}`,
  };
  const oDataOptions = {
    contentType: 'application/json',
    path: oDataConfig.odataPath,
    oDataToken: oDataConfig.odataToken,
  };
  const baseURL = `${oDataConfig.odataPath}/CheckPointEntities/HealthCheck.GetHealthCheckDataV2`;
  const payload = {
    CheckpointEntities: [
      {
        CheckpointEntityId: 20358,
        CheckpointEntityLevel: 'Campaign',
      },
    ],
    CheckpointIdentifiers: [
      {
        CheckpointKey: 'LimitedByAutoBidTargetPerf',
        CheckpointDataTypes: ['SummaryView'],
      },
      {
        CheckpointKey: 'BudgetConstraint',
        CheckpointDataTypes: ['SummaryView'],
      },
    ],
  };
  const options = _.extend(
    {},
    oDataOptions,
    {
      url: baseURL,
      data: payload,
    }
  );
  return odata.post(options);
};
